import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import type { CurrentUser } from '../../api/types/auth';
import { isFeatureEnabled } from '../../config/featureFlags';
import LogsListPage from './pages/LogsListPage';
import LogDetailPage from './pages/LogDetailPage';

const isVisible = (user: CurrentUser | null) => !!user?.isMasterGsa && isFeatureEnabled('HasLogs');

export const logsModule: ModuleDefinition = {
  routes: [
    { path: 'logs', element: <LogsListPage /> },
    { path: 'logs/:sessionId', element: <LogDetailPage /> },
  ],
  menuItems: [
    {
      label: 'Sistem Logları',
      path: 'logs',
      icon: <ManageSearchOutlinedIcon />,
      group: 'Loglar',
      groupIcon: <BugReportOutlinedIcon />,
      isVisible,
    },
  ],
};
